import { Chip } from "@mui/material";

const statusStyles = {
  active: {
    color: "#17663E",
    backgroundColor: "#E7F4EC",
  },
  online: {
    color: "#17663E",
    backgroundColor: "#E7F4EC",
  },
  success: {
    color: "#17663E",
    backgroundColor: "#E7F4EC",
  },
  generated: {
    color: "#17663E",
    backgroundColor: "#E7F4EC",
  },
  inactive: {
    color: "#616873",
    backgroundColor: "#ECEEF1",
  },
  offline: {
    color: "#616873",
    backgroundColor: "#ECEEF1",
  },
  disabled: {
    color: "#616873",
    backgroundColor: "#ECEEF1",
  },
  warning: {
    color: "#875100",
    backgroundColor: "#FFF0D7",
  },
  failed: {
    color: "#A4121E",
    backgroundColor: "#FBE6E8",
  },
  error: {
    color: "#A4121E",
    backgroundColor: "#FBE6E8",
  },
};

export function StatusChip({ label, status }) {
  const key = String(status || label || "inactive").toLowerCase();
  const style = statusStyles[key] || statusStyles.inactive;

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        ...style,
        border: 0,
        textTransform: "capitalize",
      }}
    />
  );
}
